// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"35":"ba632bcd","884":"0944f65e"}[chunkId] + ".css";
};